import React from 'react'
import { useTranslate } from '../../src/hooks/useTranslate'
import { WidthBound } from '../WidthBound'

export interface SearchResultWrapperProps {
	hits: object[]
}
export const SearchResultWrapper: React.FC<SearchResultWrapperProps> = ({
	hits, children
}) => {
	const translate = useTranslate()

	if(hits.length === 0)
	{
		return <WidthBound>
			<h2>{translate('search-noMatch')}</h2>
		</WidthBound>;
	}

	return <>{ children }</>;
}
